import { getServices } from '~/db/services';

import DialogActionRequest from '~/components/dialog/action-request/DialogActionRequest.vue';

export const useActionProfileRequest = () => {
  const { $db } = useNuxtApp();

  const { mediasService } = getServices($db);

  const { onPlay, complete, isRootPath } = useAbstractAction(
    'actionProfileRequest',
    true,
    7000
  );

  const profile = useProfileStore();

  const dialog = useDialogStore();

  const processActionRequest = async (actionRequest: ProfileActionRequest) => {
    let mediaObject: MediaSchema;
    if (actionRequest.mediaId) {
      mediaObject = await mediasService.get({
        id: actionRequest.mediaId,
      });
      if (!mediaObject) {
        const request = await useApiFetch(`/media/${actionRequest.mediaId}`);
        mediaObject = request.result ? request.result : null;
      }
    }
    const { mandatory, title, bulletList, actions } = actionRequest;
    dialog.open(DialogActionRequest, {
      mediaObject,
      mandatory,
      title,
      bulletList,
      actions,
      onClose: () => {},
    });
  };

  onPlay(async () => {
    if (isRootPath.value && profile.actionRequest) {
      processActionRequest(profile.actionRequest);
      complete(true);
    } else {
      complete(false);
    }
  });
};
